import { Component, OnInit } from '@angular/core';
import { SupporterService } from 'src/app/services/supporter.service';
import { BehaviorSubject } from 'rxjs';
import { FilterOption } from 'src/app/models/filter-option';
import { Router } from '@angular/router';

@Component({
  selector: 'app-supporters',
  templateUrl: './supporters.component.html',
  styleUrls: ['./supporters.component.scss']
})
export class SupportersComponent implements OnInit {
  public paginatedSupporters = new BehaviorSubject<any>(null);
  public loadedSupporters:boolean=false;
  public availableFilters=[];
  public filterString='';
  public sorts='';
  public page:number=1;
  public perPage:number=20;

  constructor(
    private _supporter: SupporterService,
    private _router: Router
  ) {
    this.availableFilters.push(new FilterOption({
      name: 'name',
      type: 'string'
    }));
  }

  public getSupporters(page, perPage){
    this._supporter.getSupportersPaginated(page, perPage, this.sorts, this.filterString).subscribe(paginatedData=>{
      this.paginatedSupporters.next(paginatedData);
      this.loadedSupporters = true;
    })
  }

  public addSupporter(){
    if(confirm('Confirm you want to add a new Supporter')){
      this._supporter.addSupporter().subscribe(
        (res:any) => {
          this._router.navigate(['/supporters/' + res.id]);
        }
      );
    }
  }

  sortChanged(data){
    this.sorts=data;
    this.getSupporters(1, this.perPage);
  }

  filterChanged(filters){
    this.filterString = filters;
    this.getSupporters(1, this.perPage);
  }

  pageChanged(data){
    this.perPage=data.pageSize;
    this.getSupporters(data.pageIndex+1, this.perPage);
  }

  perPageChanged(data){

  }

  ngOnInit() {
    this.getSupporters(this.page, this.perPage);
  }

}
